import { APIRoute } from '@/modules/utils'
import { PartnerQuoteProspect } from '@/data'

export const Route: APIRoute = {
  method: 'POST',
  path: `/v3/insurances/check`,
}

export type Body = {
  identifier: string
  insurance: string
}

export type Response = PartnerQuoteProspect
